module.exports = require('./lib/core/core');


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/core.js
// module id = uQ5w
// module chunks = 0